import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import {
  QaiAccordianComponent,
  QaiFieldComponent,
  QaiFloatingSelectComponent,
  QaiFloatingSelectOption,
  QaiItemGridComponent,
  QaiTextareaComponent,
  TextareaAutosizeDirective,
  QaiTrimLeadingDirective,
  QaiPasteCleanDirective,
  QaiFlexContainerComponent,
  QaiIconComponent,
  QaiDragHandleDirective,
} from '@qai/ui';
import { TRANSLOCO_SCOPE, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { AuthorReactiveFormService } from 'src/app/pages/self-serve/simulation-builder/services/author-reactive-form.service';

@Component({
  selector: 'messaging-theme-message',
  standalone: true,
  templateUrl: './messaging-theme-message.component.html',
  styleUrls: ['./messaging-theme-message.component.scss'],
  imports: [
    QaiFieldComponent,
    FormsModule,
    CommonModule,
    QaiAccordianComponent,
    QaiFloatingSelectComponent,
    QaiItemGridComponent,
    QaiTextareaComponent,
    TextareaAutosizeDirective,
    ReactiveFormsModule,
    QaiTrimLeadingDirective,
    QaiPasteCleanDirective,
    QaiFlexContainerComponent,
    TranslocoModule,
    QaiIconComponent,
    QaiDragHandleDirective,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class MessagingThemeMessageComponent implements OnInit {
  @Input() sectionUuid: string = '';
  @Input() factIndex!: number;
  @Output() deleteFactRequested = new EventEmitter<{
    index: number;
    factUuid: string;
  }>();
  form!: FormGroup;
  callUuid: string = '';
  private _currentFact!: FormGroup;
  threshold: string = '7';
  readOnly: boolean = false;
  messageType: string = 'Scorable';

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authorReactiveFormService: AuthorReactiveFormService,
    private translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap?.get('uuid')!;
    this.setThreshholdValue();
    this.setReadOnlyMode();
  }

  setThreshholdValue() {
    const currentFactValue = this.currentFact.value;
    this.threshold = String(currentFactValue.threshold);
  }

  private setReadOnlyMode() {
    this.readOnly = this.authorReactiveFormService.isReadOnly(this.callUuid);
    this.authorReactiveFormService.setReadOnlyMode(
      this.callUuid,
      this.currentFact?.get('rawText')!,
    );

    this.authorReactiveFormService.setReadOnlyMode(
      this.callUuid,
      this.currentFact?.get('displayTextCorrect')!,
    );

    this.authorReactiveFormService.setReadOnlyMode(
      this.callUuid,
      this.currentFact?.get('displayTextIncorrect')!,
    );
  }

  @Input()
  set currentFact(value: FormGroup) {
    this._currentFact = value;
    console.log('Current fact received via setter:', this._currentFact.value);
  }

  get currentFact(): FormGroup {
    return this._currentFact;
  }

  get optionButton(): any | null {
    if (this.factIndex > 0) {
      return {
        label: this.translocoService.translate('simulationBuilder.DELETE'),
        icon: 'trash',
        onClick: () => this.handleDeleteFact(),
      };
    }
    return null;
  }

  handleDeleteFact(): void {
    this.deleteFactRequested.emit({
      index: this.factIndex,
      factUuid: this.currentFact.value.uuid,
    });
  }

  valueChange(event: string, index?: number) {
    this.threshold = event;
    console.log('value change button clicked.!', this.threshold);
    this.currentFact.patchValue({ threshold: this.threshold });
  }

  selectionChange(event: QaiFloatingSelectOption | undefined) {
    console.log('Selection change button clicked.!');
  }

  thresholdOptions = Array.from({ length: 10 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }));

  messageTypeOptions = [
    {
      value: 'Scorable',
      label: 'Scorable',
    },
  ];
}
